import React, { MouseEvent } from "react";

import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getUrlDomainName } from "@mapmycustomers/shared/util/url";

import { formatLink } from "../../util/formatters";

// To avoid bubbling up
// It's not a rare event when this component is used inside some table with a Row click
// handler. And we don't want the table to catch clicking on the row when user is actually
// clicking on this link.
const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
  e.stopPropagation();
};

interface Props {
  className?: string;
  value: string;
}

const Website: React.FC<Props> = ({ className, value }) => {
  if (!value) {
    return <>{""}</>;
  }

  return (
    <div className={className}>
      <a
        href={formatLink(value as string)}
        onClick={handleClick}
        rel="noopener noreferrer"
        target="_blank"
      >
        {getUrlDomainName(value)}
        &nbsp;
        <FontAwesomeIcon icon={faExternalLinkAlt} size="xs" />
      </a>
    </div>
  );
};

export default Website;
